'use strict';
//wait for the document to be ready
document.addEventListener('DOMContentLoaded', ()=> {
  init();
});


function init () {
  accordion();
  splitMainMenuLinks();
  triggerSlickForCarousel_40_60();
  preventAddToCart();
  triggerChannelAdvisor();
  convertComparisonTable();
  observeTable();
  wrapLegalMarks()
}

function triggerSlickForCarousel_40_60() {
  const body = document.querySelector('body');
  const carousels = document.querySelectorAll('.edgewell-slick-slider');

  if(!carousels || carousels.length < 1) return;

  carousels.forEach(carousel => {
    const slickSliderPreview = carousel.querySelector('.slick-slider__preview');
    if (!slickSliderPreview) return;

    const slides = carousel.querySelectorAll('.slick-slider-item');
    const slickSetting_showArrows_desktop = slickSliderPreview.getAttribute('data-edgewellslick-show-arrows-desktop') === 'true';
    const slickSettings = {
      slidesToShow_desktop: 1,
      slidesToShow_mobile: 1,
      showArrows_desktop: slickSetting_showArrows_desktop,
      showArrows_mobile: false
    }




    $(slickSliderPreview).slick({
      slidesToShow: slickSettings.slidesToShow_desktop,
      slidesToScroll: 1,
      arrows: slickSetting_showArrows_desktop,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: false,
        responsive: [
          {
            //breakpoint 1500px and below
            breakpoint:1500,
            settings: {
              arrows: false,
              infinite: false,
              dots: true,
              slidesToShow: 1
            }
          }
        ]
    });

    if(slides.length < 2) {
      hideSlickDot(carousel);
    }

  })

}
function hideSlickDot(carousel) {
  const slickDots = carousel.querySelector('.slick-dots');
  if (!slickDots) return;

  slickDots.style.display = 'none';
}

function preventAddToCart() {
  const addToCartBtns = document.querySelectorAll('.ProductForm__AddToCart');

  if(addToCartBtns.length < 1) return;

  document.addEventListener('click', (evt) => {
    let btn = evt.target.closest('.ProductForm__AddToCart');
    if (!btn) return
    evt.preventDefault();
  })

}
function triggerSlickForModals (){
  const body = document.querySelector('body');

  if(!body) return;

  body.addEventListener('click', evt => {
    const modalTriggerBtn = evt.target.closest('button[data-modal-content-id^="leadership_"]');
    if (!modalTriggerBtn) return

    const slickSliderPreview = document.querySelector('#js-modal .slick-slider__preview');
    const slickSliderThumbs = document.querySelector('#js-modal .slick-slider__thumbnails');

    if (!slickSliderPreview || !slickSliderThumbs) return;
    $('#js-modal .slick-slider__preview').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
    });
    $('#js-modal .slick-slider__thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '#js-modal .slick-slider__preview',
      infinite: true,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: false
    });
  })
}
function assignClassToParent (element, closestParent, className) {
  if (!element) return;

  if (element.closest(closestParent)) {
    element.closest(closestParent).classList.add(className);
  }
}
function toggleAccordion(trigger,target) {
  if (trigger.getAttribute('aria-expanded') === 'true'){
    target.setAttribute('data-visible', 'false');
    trigger.setAttribute('aria-expanded', 'false');
  }
  else {
    target.setAttribute('data-visible', 'true');
    trigger.setAttribute('aria-expanded', 'true');
  }
}
function accordion() {
  const accordionHeaders = document.querySelectorAll('[data-accordion-header]');

  if (!accordionHeaders) return;

  accordionHeaders.forEach(header => {

    const accordionBody = document.getElementById(header.getAttribute('aria-controls'));

    //Add a click event listener to the header
    header.addEventListener('click', () => {
      toggleAccordion(header,accordionBody);
    });
  });
}
function splitMainMenuLinks() {
  const mainMenu = document.getElementById('shopify-section-header');
  if (!mainMenu) return

  const mainMenuLinks = mainMenu.querySelectorAll('.Header__Wrapper.split-links .Header__FlexItem.region-one .HorizontalList__Item');
  if (!mainMenuLinks) return

  const totalLinks = mainMenuLinks.length;
  //We want to find split point. And since arrays start at 0, we need to subtract 1 from the total;
  const splitPoint = (Math.ceil(totalLinks / 2) - 1);
  mainMenuLinks[splitPoint].classList.add('spacer');

}

function triggerChannelAdvisor() {

  var modal = document.getElementById("caWtbModal");
  var btn = document.getElementById("caWtbBtn");
  var btnQv = document.getElementById("qvWtbButton");
  var span = document.getElementById("caWtbClose");
  if (btn !== null) {
    btn.onclick = function() {
      var modelNumber = btn.getAttribute('data-model');
      modal.classList.toggle("modal-open");
      document.getElementById("caWtbIframe").src = "https://where-to-buy.co/widgets/core/shoppable/index.html?pid=12044576&model=" + modelNumber;
    }
  }
  if (btnQv !== null) {
    btnQv.onclick = function() {
      var modelNumberQV = btnQv.getAttribute('data-model');
      modal.classList.toggle("modal-open");
      document.getElementById("caWtbIframe").src = "https://where-to-buy.co/widgets/core/shoppable/index.html?pid=12044576&model=" + modelNumberQV;
    }
  }
  span.onclick = function() {
    modal.classList.toggle("modal-open");
  }
  window.onclick = function(event) {
    if (event.target === modal) {
      modal.classList.toggle("modal-open");
    }
  }

  /********
  Change WTB `data-mm-ids` attribute when variant changes - START
  ********/
  const wtbVariantBarcodes = getWTBVariantBarcodes();

  document.addEventListener('variant:changed', (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    updateWTBButton(wtbVariantBarcodes[variant.id] || variant.barcode || '');
  });

  function getWTBVariantBarcodes() {
    const barcodeData = document.querySelector('[data-wtb-variant-barcodes]');
    if (!barcodeData) return {};

    try {
      return JSON.parse(barcodeData.textContent);
    } catch (err) {
      console.log('WTB barcode data parsing failed:', err);
      return {};
    }
  }

  function updateWTBButton(value) {
    let wtbButton = document.querySelector('.caWtbBtn');
    if (!wtbButton) return;
    wtbButton.setAttribute('data-mm-ids',value);
  }

  /********
   Change WTB `data-mm-ids` attribute when variant changes - END
   ********/
}

function convertComparisonTable() {
  const comparisonSnippet = document.querySelector('.edgewell-snippets--playtexComparison');
  if (!comparisonSnippet) return;
  const comparisonTable = comparisonSnippet.querySelector('table');

  const tableCells = comparisonTable.querySelectorAll('td');

  tableCells.forEach(cell => {
    if (cell.textContent.toLowerCase() === 'yes') {
      convertTextToDot(cell,'Yes')
    }
    if (cell.textContent.toLowerCase() === 'no') {
      convertTextToDot(cell,'No')
    }
    if (cell.textContent.toLowerCase() === 'none') {
      convertTextToDot(cell,'None')
    }
  });
  function convertTextToDot(cell,string) {
    const innerCellSpan = document.createElement('span');
    innerCellSpan.classList.add('chart--dot');
    innerCellSpan.classList.add(`chart--${string.toLowerCase()}`);
    innerCellSpan.classList.add('text--center');
    innerCellSpan.setAttribute('title', string.toUpperCase());
    innerCellSpan.style.position = 'relative';
    innerCellSpan.style.cursor = 'pointer';
    const innerCellSpanText = document.createElement('span');
    innerCellSpanText.classList.add('sr-only');
    innerCellSpanText.style.color = 'black';
    innerCellSpanText.textContent = string.toUpperCase();
    cell.textContent = '';
    cell.appendChild(innerCellSpan);
    innerCellSpan.appendChild(innerCellSpanText);
  }


}

function observeTable() {
  const observableTables = document.querySelectorAll('[data-edgewell-observer-overflow="true"]');
  const toleranceBeforeEdge = 40;
  if (observableTables.length === 0) return;
  observableTables.forEach(table => {
    const tableWrapper = table.querySelector('.table-container__innerWrapper');
    const overflowTable = table.querySelector('table');
    toggleOverlay(tableWrapper, overflowTable, toleranceBeforeEdge, 'hide-overflow-gradient');
    tableWrapper.addEventListener('scroll', function () {
      // console.log('scrolling');
      toggleOverlay(tableWrapper, overflowTable, toleranceBeforeEdge, 'hide-overflow-gradient');
    });

    function toggleOverlay(parent, child, tolerance, className) {
      if ((child.getBoundingClientRect().right - tolerance) <= parent.getBoundingClientRect().right) {
        table.classList.add(className);
      } else {
        table.classList.remove(className);
      }
    }
  });
}

function wrapLegalMarks() {
  let lang = document.documentElement.getAttribute('lang')

  const markByLang = {
    "en": ["®"],
    "fr": ["MC","MD"],
  }
  const classNames = [
    ".ArticleItem__Excerpt",
    ".Faq__Question",
    ".Header__MainNav",
    ".ProductItem__Title",
    ".ProductMeta__Title",
    ".Rte",
    ".SidebarMenu__Nav.SidebarMenu__Nav--primary",
    ".Slideshow__Content",
    ".article-focus__excerpt",
    ".callout-card-item__content",
    ".collectionHeader--title",
    ".icon-callout__header",
    ".section--liquid",
    ".section--simple-text-columns .block-item--content",
    ".slick-slider-item",
    ".static-focus__excerpt",
  ];

  const marksInScope = markByLang[lang];
  classNames.forEach(className => {
    const elements = document.querySelectorAll(className);
    if (elements.length === 0) return;
    elements.forEach(element => {
      marksInScope.forEach(targetMark => {
        const text = element.innerHTML;
        const regex = new RegExp(targetMark, 'g');
        const matches = text.match(regex);

        if (matches === null) return
        const newString = text.replace(regex, `<sup data-edgewell-jsSwapped>${targetMark}</sup>`);
        element.innerHTML = newString;
      })


      //clean up any double `<sup>` which may have been created in process
      const supers = element.querySelectorAll('sup');
      supers.forEach(sup => {
        if (sup.parentNode.nodeName === 'SUP') {
          //ORIGINAL - Changed temporarily to fix issues with items in span being colored 'hotpink' when in a header
          // const span = document.createElement('span');

          // NEW
          const newDiv = document.createElement('div');

          newDiv.classList.add('display-inline-block');
          newDiv.innerHTML = sup.parentNode.innerHTML;
          sup.parentNode.parentNode.replaceChild(newDiv,sup.parentNode);
        }
      })
    })
  })
}
